import { useEffect, useMemo, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export function useClientPagination(items, initialTake = 25) {
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(initialTake);
  const total = items.length;
  const totalPages = Math.max(1, Math.ceil(total / take));

  useEffect(() => {
    setPage((current) => Math.min(current, totalPages));
  }, [totalPages]);

  const pageItems = useMemo(
    () => items.slice((page - 1) * take, page * take),
    [items, page, take],
  );

  return { pageItems, page, setPage, take, setTake, total, totalPages };
}

export default function ClientPagination({ pagination, label = "records" }) {
  const { pageItems, page, setPage, take, setTake, total, totalPages } = pagination;
  const start = total ? (page - 1) * take + 1 : 0;
  const end = (page - 1) * take + pageItems.length;

  return (
    <div className="flex flex-col gap-3 border-t border-gray-100 bg-gray-50/70 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm text-gray-600">Showing <strong>{start}–{end}</strong> of <strong>{total}</strong> {label}</p>
      <div className="flex flex-wrap items-center gap-3">
        <select value={take} onChange={(event) => { setTake(Number(event.target.value)); setPage(1); }} className="h-10 rounded-lg border border-gray-200 bg-white px-3 text-sm">
          <option value="25">25 / page</option><option value="50">50 / page</option><option value="100">100 / page</option>
        </select>
        <button type="button" disabled={page <= 1} onClick={() => setPage(page - 1)} className="inline-flex h-10 items-center gap-1 rounded-lg border border-gray-200 bg-white px-3 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-40"><FiChevronLeft /> Previous</button>
        <span className="text-sm font-semibold text-gray-700">Page {page} / {totalPages}</span>
        <button type="button" disabled={page >= totalPages} onClick={() => setPage(page + 1)} className="inline-flex h-10 items-center gap-1 rounded-lg border border-gray-200 bg-white px-3 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-40">Next <FiChevronRight /></button>
      </div>
    </div>
  );
}
